module.exports = __webpack_public_path__ + "static/media/delivery-man.7fbb44c8.svg";